/* Quaza Track hub controller (/pages/price-tracker). The Track bar, the theme switch and the Sets menu
   are assets/track-nav.js; this draws everything else, as views of one Shopify page routed with
   ?product= and ?index= (pushState, so Back works):
     market   the pulse line, the market list (Sealed or Singles, a set, a sort), the Quaza Index card,
              the week's movers, the index table, and search over every tracked product and set
     product  one product: chart, figures, and our listing when we sell it
     index    one index: chart, figures and members; or every set index (?index=sets)
   Every figure comes from the static price files through QuazaTrackData (assets/quaza-track-data.js),
   never from the prices Worker the iOS app depends on. */
(function () {
  'use strict';
  var root = document.querySelector('[data-qpt]');
  if (!root || !window.QuazaPriceChart || !window.QuazaTrackData) return;
  var D = window.QuazaTrackData;
  var C = window.QuazaPriceChart;
  function $(sel) { return root.querySelector(sel); }

  var marketEl = $('[data-qpt-market]');
  var productEl = $('[data-qpt-product]');
  var catalogEl = $('[data-qpt-catalog]');
  var moreBtn = $('[data-qpt-more]');
  var countEl = $('[data-qpt-count]');
  var erasEl = $('[data-qpt-eras]');
  var stripEl = $('[data-qpt-strip]');
  var setsEl = $('[data-qpt-sets]');
  var sortEl = $('[data-qpt-sort]');
  var sortWrap = $('[data-qpt-sortsel]');
  var viewEl = $('[data-qpt-view]');
  var mktEl = $('[data-qpt-mkt]');
  var filterLine = $('[data-qpt-filterline]');
  var searchEl = $('[data-qpt-search]');
  var searchX = $('[data-qpt-search-x]');
  var resultsEl = $('[data-qpt-covresults]');
  var pulseEl = $('[data-qpt-pulse]');
  var moversEl = $('[data-qpt-movers]');
  var mvTabs = $('[data-qpt-mvtabs]');
  var mvAll = $('[data-qpt-mvall]');
  var ixChart = $('[data-qpt-ixchart]');
  var ixV = $('[data-qpt-ixv]');
  var ixC = $('[data-qpt-ixc]');
  var ixP = $('[data-qpt-ixp]');
  var ixDate = $('[data-qpt-ixdate]');
  var ixList = $('[data-qpt-ixlist]');
  var ixTabs = $('[data-qpt-ixtabs]');
  var ixMore = $('[data-qpt-ixmore]');
  var updatedEl = $('[data-qpt-updated]');
  var updatedFoot = $('[data-qpt-updated-foot]');
  var megaNavEl = $('[data-qpt-meganav]');
  var panelEl = $('[data-qpt-panel]');

  var products = [];
  var byId = {};
  var mode = 'sealed';     // 'sealed' | 'singles': two separate markets
  var activeSet = null;    // a set_name, or null
  var activeEra = null;    // an era label (see eraOf), or null
  var activeType = null;   // a sealed product type key (see PTYPES), or null
  var sort = 'featured';   // 'featured' = newest sets first, grouped by set
  var view = root.getAttribute('data-qview') === 'list' ? 'list' : 'grid'; // picture cards, or the price table
  var shown = 0;           // groups (featured) or products (flat) on screen
  var moverDir = 'up';
  var ixKind = 'sets';
  var ixAllOpen = false;
  var lastIdx = null;      // the 3-month index file
  var idxPayloadCache = {};
  var logoMap = {};
  var baseTitle = document.title;
  var updatedAtText = '';
  var widget = null;

  var GROUP_ROWS = 4;      // products per set in the "Newest sets" list
  var SHELF_MIN = 3;       // the fewest cards a set's grid row shows (990-1139px); more than that gets "All N"
  var SHELF_CARDS = 10;    // cards per set in the "Newest sets" grid (one row from 750px, CSS hides the rest; a swipe row on phones)
  var GROUP_PAGE = 5;      // sets per page of it
  var ROW_PAGE = 25;       // rows per page of every other list
  var CARD_PAGE = 20;      // cards per page of every other grid (whole rows at 2, 4 and 5 across)
  var IX_ROWS = 8;         // set indexes before "All"
  var MISC_SET = 'Miscellaneous Cards & Products';

  function inMode(p) { return mode === 'singles' ? p.type === 'single' : p.type !== 'single'; }

  /* ---------- taxonomy: eras, release order, product types ----------
     The catalogue carries language and set_release per product: non-English sets group as one
     "International" era (shown as Japanese, the only other language), newest release first. */
  function eraOf(p) {
    if (p.language && p.language !== 'EN') return 'International';
    var e = p.era || 'Other';
    return e === 'Other' ? 'Special Sets' : e;
  }
  var ERA_LABELS = { Mega: 'Mega Evolution', International: 'Japanese' };
  function eraLabel(era) { return ERA_LABELS[era] || era; }

  /* order matters: 'Ultra-Premium Collection' must classify before 'Collection' */
  var PTYPES = [
    { key: 'etb', label: 'Elite Trainer Boxes', one: 'Elite Trainer Box', re: /elite trainer/i },
    { key: 'upc', label: 'Ultra-Premium Collections', one: 'Ultra-Premium Collection', re: /ultra.?premium/i },
    { key: 'booster-box', label: 'Booster Boxes', one: 'Booster Box', re: /booster (box|display)/i },
    { key: 'booster-bundle', label: 'Booster Bundles', one: 'Booster Bundle', re: /booster bundle/i },
    { key: 'collection', label: 'Collection Boxes', one: 'Collection Box', re: /collection/i }
  ];
  function ptypeOf(p) {
    if (p.type === 'single') return null;
    for (var i = 0; i < PTYPES.length; i++) if (PTYPES[i].re.test(p.name)) return PTYPES[i].key;
    return 'other';
  }
  function ptypeDef(key) { return PTYPES.filter(function (t) { return t.key === key; })[0] || null; }

  var SET_INFO = {}; // set_name -> { rel, era, lang, sealed, singles }
  var ERA_RANK = {}; // era label -> display rank
  function buildTaxonomy() {
    SET_INFO = {};
    var maxRel = {};
    products.forEach(function (p) {
      var s = SET_INFO[p.set_name] ||
        (SET_INFO[p.set_name] = { rel: '', era: eraOf(p), lang: p.language === 'EN' ? 'EN' : 'JP', sealed: 0, singles: 0 });
      if (p.set_release && p.set_release > s.rel) s.rel = p.set_release;
      if (p.type === 'single') s.singles++; else s.sealed++;
      var l = eraOf(p);
      if (!(l in maxRel) || (p.set_release || '') > maxRel[l]) maxRel[l] = p.set_release || '';
    });
    // eras newest first; cross-era Special Sets after the real eras, Japanese last
    function bucket(l) { return l === 'International' ? 2 : l === 'Special Sets' ? 1 : 0; }
    ERA_RANK = {};
    Object.keys(maxRel).sort(function (a, b) {
      if (bucket(a) !== bucket(b)) return bucket(a) - bucket(b);
      return maxRel[a] < maxRel[b] ? 1 : -1;
    }).forEach(function (l, i) { ERA_RANK[l] = i; });
  }
  function setRel(name) { return (SET_INFO[name] && SET_INFO[name].rel) || ''; }
  /* newest release first, the misc bucket last */
  function bySetAge(a, b) {
    var ma = a === MISC_SET ? 1 : 0, mb = b === MISC_SET ? 1 : 0;
    if (ma !== mb) return ma - mb;
    var ra = setRel(a), rb = setRel(b);
    if (ra !== rb) return ra < rb ? 1 : -1;
    return String(a).localeCompare(String(b));
  }
  /* sets of the current market (and era), newest first */
  function setsFor(era) {
    var seen = {}, out = [];
    products.forEach(function (p) {
      if (!inMode(p) || seen[p.set_name]) return;
      if (era && eraOf(p) !== era) return;
      seen[p.set_name] = 1;
      out.push(p.set_name);
    });
    return out.sort(bySetAge);
  }
  /* "ME05: Pitch Black" -> "Pitch Black"; the code stays in the set picker's own label */
  function setLabel(name) { return String(name || '').replace(/^[A-Za-z0-9.]+:\s+/, ''); }

  /* ---------- helpers ---------- */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  /* loading='lazy' BEFORE src: the other way round WebKit starts every download the moment src is
     set, and an iPhone fetched all ~234 product images on first load (measured 2026-10-08). */
  function img(src, alt, size) {
    var i = document.createElement('img');
    i.loading = 'lazy';
    i.decoding = 'async';
    i.alt = alt || '';
    i.width = size; i.height = size;
    if (src) i.src = src;
    return i;
  }
  /* The feed's CDN serves 200px copies; a 44px thumbnail at 3x needs no more */
  function thumb(url) { return url ? String(url).replace('_in_400x400.', '_in_200x200.').replace(/(qt-card-\d+\.jpg\?width=)287/, '$1144') : url; }
  /* A card's picture shows about 130 to 160px wide: a 200px copy for a 1x screen, the 400px one for
     2x and 3x (the browser picks). The feed's CDN and Shopify's both serve the smaller copy. srcset and
     sizes go on before src, after loading=lazy, for the reason img() gives. */
  function cardImg(url) {
    var i = document.createElement('img');
    i.loading = 'lazy';
    i.decoding = 'async';
    i.alt = '';
    i.width = 400; i.height = 400;
    if (!url) return i;
    var u = String(url), set = null;
    if (u.indexOf('_in_400x400.') !== -1 || /qt-card-\d+\.jpg\?width=287/.test(u)) set = thumb(u) + (u.indexOf('qt-card-') !== -1 ? ' 144w, ' + u + ' 287w' : ' 200w, ' + u + ' 400w');
    else if (/^https:\/\/cdn\.shopify\.com\//.test(u)) {
      var q = u.indexOf('?') === -1 ? '?' : '&';
      set = u + q + 'width=200 200w, ' + u + q + 'width=400 400w';
      u = u + q + 'width=400';
    }
    if (set) { i.sizes = '(min-width: 750px) 160px, 34vw'; i.srcset = set; }
    i.src = u;
    return i;
  }
  /* a change in percent: "+1.2%", "−3.4%", a flat "0%", or a dash when there is none */
  function pct(v) { return v == null ? '–' : v === 0 ? '0%' : (v > 0 ? '+' : '−') + Math.abs(v) + '%'; }
  function dir(v) { return v == null || v === 0 ? '' : v > 0 ? ' up' : ' down'; }
  function chgEl(v, tag) { return el(tag || 'span', 'qpt-chg' + dir(v), pct(v)); }
  // kept for the product view and index pages, which read these names
  function chgText(v) { return chgEl(v); }
  function chip(v) { return chgEl(v); }
  function fmtPts(v) { return v == null ? '–' : v.toFixed(2); }
  /* The index level in plain English: under the MSRP basis a level IS a premium. Whole percent. */
  function premiumSentence(level) {
    if (level == null) return '';
    var d = Math.round(level - 100);
    if (d === 0) return 'Trading at MSRP';
    return d > 0 ? 'Trading ' + d + '% above MSRP' : 'Trading ' + Math.abs(d) + '% below MSRP';
  }
  function fold(t) { return String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); }
  function lastOf(arr) { for (var i = arr.length - 1; i >= 0; i--) if (arr[i] != null) return { i: i, v: arr[i] }; return null; }
  /* publish's changeOver on a dense daily array: last point vs the last one at or before `days` back */
  function changeOver(arr, days) {
    var last = lastOf(arr);
    if (!last) return null;
    for (var i = last.i - 1; i >= 0; i--) {
      if (arr[i] == null || i > last.i - days) continue;
      if (i < last.i - days - 7 || !(arr[i] > 0)) return null;
      return Math.round(((last.v - arr[i]) / arr[i]) * 1000) / 10;
    }
    return null;
  }
  /* track_sync's spark_path, so a client-drawn sparkline matches a server-printed one exactly */
  function sparkPath(vals) {
    vals = vals.filter(function (v) { return v != null; });
    if (vals.length < 2) return null;
    var n = vals.length, s = vals.slice().sort(function (a, b) { return a - b; });
    var lo = s[Math.floor((n - 1) * 0.02)], hi = s[Math.ceil((n - 1) * 0.98)];
    if (!(hi > lo)) { lo = s[0]; hi = s[n - 1]; }
    var span = (hi - lo) || 1;
    lo -= span * 0.06; hi += span * 0.06; span = hi - lo;
    var step = 240 / (n - 1), out = '';
    for (var i = 0; i < n; i++) {
      var t = Math.min(1, Math.max(0, (vals[i] - lo) / span));
      out += (i ? ' L' : 'M') + (i * step).toFixed(1) + ',' + (3 + 56 * (1 - t)).toFixed(1);
    }
    return out;
  }
  function spark(series, up) {
    var d = sparkPath((series || []).map(function (p) { return p[1]; }));
    var w = el('span', 'qpt-spark' + (up == null ? '' : up ? ' up' : ' down'));
    // a flat or missing change draws in the neutral colour
    w.setAttribute('aria-hidden', 'true');
    if (d) w.innerHTML = '<svg viewBox="0 0 240 62" preserveAspectRatio="none" focusable="false"><path class="a" d="' + d +
      ' L240,62 L0,62 Z"/><path class="l" d="' + d + '" vector-effect="non-scaling-stroke"/></svg>';
    return w;
  }

  /* Official set logos: the catalogue's set_logos map (set_name -> Shopify Files URL), an allowlist.
     ?height= asks the CDN for a small copy; two rungs so one logo shares one URL everywhere. */
  var LOGO_LADDER = [52, 88];
  function logoSrc(url, height) {
    var want = (height || 22) * 2, h = LOGO_LADDER[LOGO_LADDER.length - 1];
    for (var i = 0; i < LOGO_LADDER.length; i++) if (LOGO_LADDER[i] >= want) { h = LOGO_LADDER[i]; break; }
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'height=' + h;
  }
  function setLogo(setName, height) {
    var url = logoMap[setName];
    if (!url) return null;
    var i = img(logoSrc(url, height), '', null);
    i.removeAttribute('width'); i.removeAttribute('height');
    i.className = 'qpt-setlogo';
    i.style.height = (height || 22) + 'px';
    i.onerror = function () { if (i.parentNode) i.parentNode.removeChild(i); };
    return i;
  }

  function readJSON(sel) {
    var n = root.querySelector(sel);
    try { return (n && JSON.parse(n.textContent)) || {}; } catch (e) { return {}; }
  }
  /* Our listings by Track id and curated id (shop track.store, written daily by track_sync) */
  var storeMap = readJSON('[data-qpt-store]');
  function storeHandleFor(p) {
    var t = p._tcg != null ? (storeMap.by_tcg || {})[p._tcg] : null;
    var c = (storeMap.by_curated || {})[p.id];
    return (t && t[0]) || (c && c[0]) || null;
  }
  /* A curated set's set page handle (shop track.set_index) */
  var setPages = readJSON('[data-qpt-setmap]');
  function setPageFor(name) {
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return setPages[name] ? rootPath + 'pages/price-tracker/' + setPages[name] : null;
  }
  /* A publication set's page, from the Sets menu's links (no second copy of the list) */
  function setPageUrl(setId) {
    var a = root.querySelector('[data-qpt-setsmenu] a[data-i="' + Number(setId) + '"]');
    return a ? a.getAttribute('href') : null;
  }

  /* the product view's line under the name */
  function metaLine(p) {
    return [setLabel(p.set_name), p.era && ERA_LABELS[p.era] ? ERA_LABELS[p.era] : p.era, p.language && p.language !== 'EN' ? 'Japanese' : null, p.grade]
      .filter(Boolean).join(' · ');
  }
  function typeLabel(p) {
    if (p.type === 'single') return p.grade || '';
    var d = ptypeDef(ptypeOf(p));
    return d ? d.one : '';
  }
  /* under the name: the set, or inside a set's own list the product type, unless the name says it */
  function metaFor(p, grouped) {
    var t = typeLabel(p);
    var bits = grouped ? [fold(p.name).indexOf(fold(t)) === -1 ? t : null] : [setLabel(p.set_name)];
    if (p.language && p.language !== 'EN') bits.push('Japanese');
    return bits.filter(Boolean).join(' · ');
  }

  /* one product row: a real link (opens in a new tab with a modifier), routed in place on a plain click */
  function row(p, opts) {
    opts = opts || {};
    var a = el('a', 'qpt-row' + (opts.sm ? ' qpt-row--sm' : ''));
    a.href = '?product=' + encodeURIComponent(p.id);
    a.setAttribute('data-open', p.id);
    var im = el('span', 'qpt-row-img');
    im.appendChild(img(opts.image || thumb(p.image_url), '', opts.sm ? 36 : 52));
    a.appendChild(im);
    var main = el('span', 'qpt-row-main');
    main.appendChild(el('span', 'qpt-row-name', p.name));
    var meta = opts.meta != null ? opts.meta : metaFor(p, opts.grouped);
    if (meta) main.appendChild(el('span', 'qpt-row-meta', meta));
    a.appendChild(main);
    var num = el('span', 'qpt-row-num');
    num.appendChild(el('span', 'qpt-row-price qpt-num', p.price_cents == null ? '–' : C.fmtCAD(p.price_cents)));
    num.appendChild(chgEl(p.change7d_pct));
    a.appendChild(num);
    return a;
  }
  /* one picture card, for the market's grid and the product view's "More in this set" row: the
     picture (cardImg), the name, the set or type under it, the price and the week's change. The
     picture's alt is empty: the name beside it is the link's text. */
  function productCard(p, opts) {
    opts = opts || {};
    var card = el('a', 'qpt-card');
    card.href = '?product=' + encodeURIComponent(p.id);
    card.setAttribute('data-open', p.id);
    var im = el('span', 'qpt-card-img');
    im.appendChild(cardImg(p.image_url));
    card.appendChild(im);
    card.appendChild(el('span', 'qpt-card-name', p.name));
    var meta = metaFor(p, opts.grouped);
    if (meta) card.appendChild(el('span', 'qpt-card-meta', meta));
    var foot = el('span', 'qpt-card-foot');
    foot.appendChild(el('span', 'qpt-card-price qpt-num', p.price_cents == null ? '–' : C.fmtCAD(p.price_cents)));
    foot.appendChild(chgEl(p.change7d_pct));
    card.appendChild(foot);
    return card;
  }
  /* fade the list in after a change; not on the first paint's swap from skeletons... it reads fine either way */
  function fadeIn(node) {
    node.classList.remove('is-in');
    void node.offsetWidth;
    node.classList.add('is-in');
  }
  function scrollToMarket() {
    var t = document.getElementById('qpt-browse');
    if (!t) return;
    var r = t.getBoundingClientRect();
    var top = parseFloat(getComputedStyle(root).getPropertyValue('--qpt-sticky-top')) || 0;
    if (r.top < top + 40 || r.top > window.innerHeight * 0.6) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ---------- market state ---------- */
  function matches(p) {
    if (!inMode(p)) return false;
    if (activeEra && eraOf(p) !== activeEra) return false;
    if (activeSet && p.set_name !== activeSet) return false;
    if (activeType && ptypeOf(p) !== activeType) return false;
    return true;
  }
  /* market URL state (?market=&era=&set=&ptype=&sort=): shareable */
  function syncMarketUrl() {
    var u = new URL(location.href);
    function put(k, v) { if (v) u.searchParams.set(k, v); else u.searchParams.delete(k); }
    put('market', mode === 'singles' ? 'singles' : null);
    put('era', activeEra);
    put('set', activeSet);
    put('ptype', activeType);
    put('sort', sort === 'featured' ? null : sort);
    history.replaceState(history.state, '', u);
  }
  function refresh(opts) {
    shown = 0;
    renderFilters();
    renderCatalog(true);
    syncMarketUrl();
    navSync();
    if (opts && opts.scroll) scrollToMarket();
  }
  /* A set keeps the era it was picked under, so the chips don't move under the tap; a set from
     another era (from a menu) widens the era to All. From the chips a product type stays on (they
     list only the sets that have it); from the menus a set starts clean. */
  function applySet(name, opts) {
    activeSet = name || null;
    if (activeSet && activeEra && (SET_INFO[activeSet] || {}).era !== activeEra) activeEra = null;
    if (activeSet && !(opts && opts.keepType)) activeType = null;
    refresh(opts);
  }
  function applyEra(era, opts) {
    activeEra = era || null;
    activeSet = null;
    refresh(opts);
  }
  function applyType(t, opts) {
    activeType = t || null;
    activeEra = null;
    activeSet = null;
    refresh(opts);
  }
  function setSort(next, opts) {
    sort = next || 'featured';
    if (sortEl) sortEl.value = sort;
    refresh(opts);
  }
  function setMode(next, keep) {
    if (mode === next) return;
    mode = next;
    if (!keep) { activeEra = null; activeSet = null; activeType = null; }
    if (mode === 'singles') activeType = null;
    // an era or set the other market doesn't have would leave an empty list
    if (activeEra && !products.some(function (p) { return inMode(p) && eraOf(p) === activeEra; })) activeEra = null;
    if (activeSet && !products.some(function (p) { return inMode(p) && p.set_name === activeSet; })) activeSet = null;
    renderPulse();
    renderMovers();
    refresh();
  }
  function resetFilters() {
    activeEra = null; activeSet = null; activeType = null;
    setSort('featured');
  }
  function setView(next) {
    if (next === view) return;
    view = next;
    root.setAttribute('data-qview', view);
    try { localStorage.setItem('qpt-view', view); } catch (e) { /* private mode: this visit only */ }
    markView();
    renderCatalog(true);
  }
  function markView() {
    if (!viewEl) return;
    viewEl.querySelectorAll('[data-v]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-v') === view ? 'true' : 'false'); });
  }

  /* ---------- market: era tabs and the set chips ----------
     Eras of the current market, newest first, with All; under them every set of the era as a chip
     with its official logo (a set without one shows its code, "M6", or initials). The chips list
     only sets that have products under the current product type. Both rows are built when what
     they list changes (market, era, type) and otherwise only re-marked, so a tap never rebuilds the
     row under the finger and the row keeps its scroll. */
  function setCode(name) {
    var m = /^([A-Za-z0-9.]+):\s+/.exec(String(name || ''));
    return m ? m[1] : initials(setLabel(name));
  }
  function inView(p) { return inMode(p) && (!activeType || ptypeOf(p) === activeType); }
  var ALL_ICON = '<span class="qpt-setchip-all" aria-hidden="true"><svg viewBox="0 0 20 20" fill="currentColor"><rect x="3" y="3" width="6" height="6" rx="1.6"/><rect x="11" y="3" width="6" height="6" rx="1.6"/><rect x="3" y="11" width="6" height="6" rx="1.6"/><rect x="11" y="11" width="6" height="6" rx="1.6"/></svg></span>';
  function setChip(name, label, count, jp) {
    var b = el('button', 'qpt-setchip');
    b.type = 'button';
    b.setAttribute('data-set', name || '');
    if (!name) b.insertAdjacentHTML('beforeend', ALL_ICON);
    else {
      var lg = setLogo(name, 24);
      if (lg) { var w = el('span', 'qpt-setchip-logo'); w.appendChild(lg); b.appendChild(w); }
      else b.appendChild(el('span', 'qpt-setchip-code', setCode(name)));
    }
    b.appendChild(el('span', 'qpt-setchip-n', label));
    if (jp) b.appendChild(el('span', 'qpt-setchip-jp', 'JP'));
    b.appendChild(el('small', 'qpt-num', String(count)));
    return b;
  }
  /* scroll a row sideways so `item` is in view (centred when it was out of it); never the page */
  function reveal(rowEl, item, smooth) {
    if (!rowEl || !item) return;
    var left = item.offsetLeft, w = rowEl.clientWidth, x = rowEl.scrollLeft;
    if (left >= x + 8 && left + item.offsetWidth <= x + w - 8) return;
    var to = Math.max(0, left - (w - item.offsetWidth) / 2);
    if (smooth && rowEl.scrollTo && !reduced()) rowEl.scrollTo({ left: to, behavior: 'smooth' });
    else rowEl.scrollLeft = to;
  }
  function reduced() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  var stripSync = function () {};
  function renderFilters() {
    if (sortWrap) sortWrap.classList.toggle('is-set', sort !== 'featured');
    if (erasEl) {
      if (erasEl.getAttribute('data-k') !== mode) {
        erasEl.textContent = '';
        var eras = [];
        products.forEach(function (p) { var e = eraOf(p); if (inMode(p) && eras.indexOf(e) === -1) eras.push(e); });
        eras.sort(function (a, b) { return (ERA_RANK[a] || 0) - (ERA_RANK[b] || 0); });
        [''].concat(eras).forEach(function (e) {
          var t = el('button', 'qpt-eratab', e ? eraLabel(e) : 'All');
          t.type = 'button';
          t.setAttribute('data-era', e);
          erasEl.appendChild(t);
        });
        erasEl.setAttribute('data-k', mode);
      }
      var onTab = null;
      erasEl.querySelectorAll('[data-era]').forEach(function (t) {
        var on = (t.getAttribute('data-era') || null) === activeEra;
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) onTab = t;
      });
      reveal(erasEl, onTab, true);
    }
    if (!setsEl) return;
    var key = mode + '|' + (activeEra || '') + '|' + (activeType || '');
    var fresh = setsEl.getAttribute('data-k') !== key;
    if (fresh) {
      setsEl.textContent = '';
      var counts = {}, all = 0;
      products.forEach(function (p) {
        if (!inView(p) || (activeEra && eraOf(p) !== activeEra)) return;
        counts[p.set_name] = (counts[p.set_name] || 0) + 1;
        all++;
      });
      setsEl.appendChild(setChip(null, activeEra ? 'All ' + eraLabel(activeEra) : 'All sets', all));
      Object.keys(counts).sort(bySetAge).forEach(function (name) {
        var jp = (SET_INFO[name] || {}).lang === 'JP' && activeEra !== 'International';
        setsEl.appendChild(setChip(name, setLabel(name), counts[name], jp));
      });
      setsEl.setAttribute('data-k', key);
      setsEl.scrollLeft = 0;
    }
    var onChip = null;
    setsEl.querySelectorAll('[data-set]').forEach(function (b) {
      var on = (b.getAttribute('data-set') || null) === activeSet;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) onChip = b;
    });
    if (activeSet) reveal(setsEl, onChip, !fresh);
    stripSync();
  }

  /* ---------- market: the list ---------- */
  function sortedFlat(list) {
    var SORTS = {
      'featured': function (a, b) {
        var ea = eraOf(a), eb = eraOf(b);
        if (ea !== eb) return (ERA_RANK[ea] || 0) - (ERA_RANK[eb] || 0);
        if (a.set_name !== b.set_name) return bySetAge(a.set_name, b.set_name);
        return (b.price_cents || 0) - (a.price_cents || 0);
      },
      'price-desc': function (a, b) { return (b.price_cents || 0) - (a.price_cents || 0); },
      'price-asc': function (a, b) { return (a.price_cents == null ? 1e15 : a.price_cents) - (b.price_cents == null ? 1e15 : b.price_cents); },
      'change-desc': function (a, b) { return (b.change7d_pct != null ? b.change7d_pct : -1e9) - (a.change7d_pct != null ? a.change7d_pct : -1e9); },
      'change-asc': function (a, b) { return (a.change7d_pct != null ? a.change7d_pct : 1e9) - (b.change7d_pct != null ? b.change7d_pct : 1e9); },
      'name': function (a, b) { return a.name.localeCompare(b.name); }
    };
    return list.slice().sort(SORTS[sort] || SORTS['price-desc']);
  }
  function thead() {
    var h = el('div', 'qpt-thead');
    h.setAttribute('aria-hidden', 'true'); // the sort select is the accessible control
    h.appendChild(el('span'));
    h.appendChild(el('span', null, 'Product'));
    [['price', 'Price'], ['change', '7D']].forEach(function (c) {
      var s = el('span');
      var b = el('button', 'qpt-th', c[1]);
      b.type = 'button';
      b.tabIndex = -1;
      b.setAttribute('data-th', c[0]);
      if (sort === c[0] + '-desc') b.setAttribute('aria-sort', 'descending');
      if (sort === c[0] + '-asc') b.setAttribute('aria-sort', 'ascending');
      s.appendChild(b);
      h.appendChild(s);
    });
    return h;
  }
  function setCard(name, n) {
    var info = SET_INFO[name] || {};
    var card = el('div', 'qpt-setcard');
    var lw = el('span', 'qpt-setcard-logo');
    var lg = setLogo(name, 34);
    if (lg) lw.appendChild(lg);
    card.appendChild(lw);
    var t = el('div');
    t.appendChild(el('p', 'qpt-setcard-n', setLabel(name) + (info.lang === 'JP' ? ' (Japanese)' : '')));
    var bits = [groupEra(name)].filter(Boolean);
    bits.push(n + (mode === 'singles' ? (n === 1 ? ' card' : ' cards') : (n === 1 ? ' sealed product' : ' sealed products')));
    var ix = lastIdx && (lastIdx.sets || []).filter(function (s) { return s.set_name === name; })[0];
    var sub = el('p', 'qpt-setcard-s', bits.join(' · '));
    if (ix && ix.level != null && mode === 'sealed') {
      sub.appendChild(document.createTextNode(' · Index ' + fmtPts(ix.level) + ' '));
      sub.appendChild(chgEl(ix.change_pct));
    }
    t.appendChild(sub);
    card.appendChild(t);
    var page = setPageFor(name);
    if (page) {
      var a = el('a', 'qpt-btn', 'Every price in this set');
      a.href = page;
      card.appendChild(a);
    }
    return card;
  }
  /* the era a group's products are from: the era picked, else the set's own. The miscellaneous
     bucket holds products of several eras, so under All it names none. */
  function groupEra(name) {
    if (activeEra) return eraLabel(activeEra);
    return name === MISC_SET ? '' : eraLabel((SET_INFO[name] || {}).era);
  }
  function groupHead(name, count) {
    var g = el('div', 'qpt-grp');
    var lw = el('span', 'qpt-grp-logo');
    var lg = setLogo(name, 26);
    if (lg) { lw.appendChild(lg); g.appendChild(lw); }
    var t = el('span', 'qpt-grp-t');
    var info = SET_INFO[name] || {};
    t.appendChild(el('span', 'qpt-grp-n', setLabel(name) + (info.lang === 'JP' ? ' (Japanese)' : '')));
    t.appendChild(el('span', 'qpt-grp-s', [groupEra(name), count + (count === 1 ? ' product' : ' products')].filter(Boolean).join(' · ')));
    g.appendChild(t);
    var page = setPageFor(name);
    if (page) {
      var a = el('a', 'qpt-link', 'Set page');
      a.href = page;
      a.setAttribute('aria-label', setLabel(name) + ' set page');
      a.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3.5 10.5 8 6 12.5"/></svg>');
      g.appendChild(a);
    }
    return g;
  }

  function renderCatalog(animate) {
    var list = products.filter(matches);
    var denom = products.filter(inMode).length;
    if (countEl) countEl.textContent = list.length === denom ? String(denom) : list.length + ' of ' + denom;
    renderFilterLine();
    catalogEl.textContent = '';
    catalogEl.removeAttribute('aria-busy');
    if (!list.length) {
      var empty = el('div', 'qpt-empty');
      empty.appendChild(el('p', null, 'Nothing here matches. Try all sets.'));
      var b = el('button', 'qpt-btn', 'Show all sets');
      b.type = 'button';
      b.addEventListener('click', resetFilters);
      empty.appendChild(b);
      catalogEl.appendChild(empty);
      moreBtn.hidden = true;
      return;
    }
    var grid = view === 'grid';
    catalogEl.classList.toggle('is-grid', grid);
    if (activeSet) catalogEl.appendChild(setCard(activeSet, list.length));
    if (!grid) catalogEl.appendChild(thead());
    var grouped = sort === 'featured' && !activeSet && !activeType;
    var groups = [], byName = {};
    if (grouped) {
      list.forEach(function (p) {
        var k = p.set_name || 'Other';
        if (!byName[k]) { byName[k] = { name: k, items: [] }; groups.push(byName[k]); }
        byName[k].items.push(p);
      });
      /* sets of one or two products (the Japanese sets today) make a row of near-empty shelves:
         the grid shows them as one grid instead, newest set first, each card naming its set */
      if (grid && groups.length > 1 && list.length < groups.length * 2) grouped = false;
    }
    if (grouped) {
      groups.sort(function (a, b) {
        var ea = (SET_INFO[a.name] || {}).era, eb = (SET_INFO[b.name] || {}).era;
        if (ea !== eb) return (ERA_RANK[ea] || 0) - (ERA_RANK[eb] || 0);
        return bySetAge(a.name, b.name);
      });
      shown = Math.min(groups.length, Math.max(shown, GROUP_PAGE));
      groups.slice(0, shown).forEach(function (g) {
        g.items.sort(function (a, b) { return (b.price_cents || 0) - (a.price_cents || 0); });
        catalogEl.appendChild(groupHead(g.name, g.items.length));
        if (grid) {
          var shelf = el('div', 'qpt-shelf');
          g.items.slice(0, SHELF_CARDS).forEach(function (p) { shelf.appendChild(productCard(p, { grouped: true })); });
          catalogEl.appendChild(shelf);
        } else {
          g.items.slice(0, GROUP_ROWS).forEach(function (p) { catalogEl.appendChild(row(p, { grouped: true })); });
        }
        if (g.items.length > (grid ? SHELF_MIN : GROUP_ROWS)) {
          var all = el('button', 'qpt-grp-all', 'All ' + g.items.length + ' in ' + setLabel(g.name));
          all.type = 'button';
          all.setAttribute('data-set', g.name);
          catalogEl.appendChild(all);
        }
      });
      var left = groups.length - shown;
      moreBtn.hidden = left <= 0;
      moreBtn.textContent = 'Show more sets (' + left + ')';
      moreBtn.setAttribute('data-step', 'groups');
    } else {
      var flat = sortedFlat(list);
      var page = grid ? CARD_PAGE : ROW_PAGE;
      shown = Math.min(flat.length, Math.max(shown, page));
      if (grid) {
        var cards = el('div', 'qpt-cards');
        flat.slice(0, shown).forEach(function (p) { cards.appendChild(productCard(p, { grouped: !!activeSet })); });
        catalogEl.appendChild(cards);
      } else {
        flat.slice(0, shown).forEach(function (p) { catalogEl.appendChild(row(p, { grouped: !!activeSet })); });
      }
      var rest = flat.length - shown;
      moreBtn.hidden = rest <= 0;
      moreBtn.textContent = 'Show ' + Math.min(page, rest) + ' more (' + rest + ' left)';
      moreBtn.setAttribute('data-step', 'rows');
    }
    if (animate) fadeIn(catalogEl);
  }
  function renderFilterLine() {
    if (!filterLine) return;
    filterLine.textContent = '';
    var def = activeType ? ptypeDef(activeType) : null;
    if (def) {
      var b = el('button', 'qpt-chipbtn', def.label);
      b.type = 'button';
      b.setAttribute('aria-label', 'Remove filter: ' + def.label);
      b.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M3 3l6 6M9 3 3 9"/></svg>');
      b.addEventListener('click', function () { applyType(null); });
      filterLine.appendChild(b);
    }
    filterLine.hidden = !filterLine.firstChild;
  }

  /* ---------- pulse: the index, the market's week, risers and fallers ---------- */
  function renderPulse() {
    if (!pulseEl) return;
    var moved = products.filter(function (p) { return inMode(p) && p.change7d_pct != null && p.price_cents != null; });
    var sum = 0, up = 0, down = 0;
    moved.forEach(function (p) { sum += p.change7d_pct; if (p.change7d_pct > 0) up++; else if (p.change7d_pct < 0) down++; });
    var avg = moved.length ? Math.round((sum / moved.length) * 10) / 10 : null;
    function put(k, txt, cls) {
      var n = pulseEl.querySelector('[data-p="' + k + '"]');
      if (!n) return;
      n.textContent = txt;
      if (cls != null) n.className = cls;
    }
    put('mktl', (mode === 'singles' ? 'Singles' : 'Sealed') + ' · 7D avg');
    put('mkt', pct(avg), 'qpt-pulse-v qpt-chg' + dir(avg));
    put('up', moved.length ? String(up) : '–');
    put('down', moved.length ? String(down) : '–');
    if (lastIdx && lastIdx.overall) {
      var o = lastIdx.overall;
      put('idx', fmtPts(o.level));
      put('idxc', pct(o.change_pct), 'qpt-chg' + dir(o.change_pct));
    }
  }

  /* ---------- rail: the Quaza Index ---------- */
  function renderIndexBox(idx) {
    var o = idx.overall || {};
    if (ixV) ixV.textContent = fmtPts(o.level);
    function setChg(v) { if (ixC) { ixC.textContent = pct(v); ixC.className = 'qpt-chg' + dir(v); } }
    setChg(o.change_pct);
    if (ixP) ixP.textContent = premiumSentence(o.level);
    if (!ixChart) return;
    var resting = ixDate ? ixDate.textContent : '';
    C.drawChart(ixChart, o.series || [], (o.change_pct || 0) >= 0, {
      fmt: fmtPts,
      guides: false,
      onScrub: function (pt) {
        if (!pt) {
          ixV.textContent = fmtPts(o.level);
          setChg(o.change_pct);
          if (ixDate) ixDate.textContent = resting;
          return;
        }
        ixV.textContent = fmtPts(pt.value);
        setChg(pt.first > 0 ? Math.round(((pt.value - pt.first) / pt.first) * 1000) / 10 : null);
        if (ixDate) ixDate.textContent = C.fmtDate(pt.date);
      }
    });
  }

  /* ---------- rail: the week's movers ---------- */
  function renderMovers() {
    if (!moversEl || !products.length) return;
    var ranked = products
      .filter(function (p) { return inMode(p) && p.change7d_pct != null && p.price_cents != null; })
      .sort(function (a, b) { return b.change7d_pct - a.change7d_pct; });
    var list = moverDir === 'up'
      ? ranked.filter(function (p) { return p.change7d_pct > 0; }).slice(0, 5)
      : ranked.filter(function (p) { return p.change7d_pct < 0; }).slice(-5).reverse();
    moversEl.textContent = '';
    if (!list.length) { moversEl.appendChild(el('p', 'qpt-empty', 'No ' + (moverDir === 'up' ? 'gainers' : 'losers') + ' this week.')); return; }
    list.forEach(function (p) { moversEl.appendChild(row(p, { sm: true, meta: setLabel(p.set_name) })); });
    fadeIn(moversEl);
  }

  /* ---------- the index table: sets or product types ---------- */
  /* "First Partner Collection 2026" -> "FP": a set with no logo gets its initials */
  function initials(name) {
    return String(name).replace(/\(.*?\)/g, '').split(/\s+/).filter(function (w) { return /^[A-Za-z]/.test(w); })
      .slice(0, 2).map(function (w) { return w[0]; }).join('').toUpperCase();
  }
  var TYPE_MONO = { etb: 'ETB', 'booster-bundle': 'BB', 'booster-box': 'BOX', collection: 'COL', upc: 'UPC' };
  function ixRow(key, name, sub, level, chg, series, logoSet, mono) {
    var a = el('a', 'qpt-ixrow');
    a.href = '?index=' + encodeURIComponent(key);
    a.setAttribute('data-goidx', key);
    var main = el('span', 'qpt-ixrow-main');
    if (logoSet !== undefined || mono) {
      var lg = logoSet ? setLogo(logoSet, 24) : null;
      if (lg) { var w = el('span', 'qpt-ixrow-logo'); w.appendChild(lg); main.appendChild(w); }
      else main.appendChild(el('span', 'qpt-ixrow-mono', mono || initials(setLabel(logoSet))));
    }
    var t = el('span', 'qpt-ixrow-t');
    t.appendChild(el('span', 'qpt-ixrow-n', name));
    t.appendChild(el('span', 'qpt-ixrow-s', sub));
    main.appendChild(t);
    a.appendChild(main);
    a.appendChild(spark(series, chg == null || chg === 0 ? null : chg > 0));
    a.appendChild(el('span', 'qpt-ixrow-v qpt-num', fmtPts(level)));
    a.appendChild(chgEl(chg));
    return a;
  }
  function renderIxTable() {
    if (!ixList || !lastIdx) return;
    ixList.textContent = '';
    var rows = [];
    if (ixKind === 'types') {
      (lastIdx.types || []).forEach(function (t) {
        rows.push(ixRow(t.key, t.name, (t.count || 0) + ' products', t.level, t.change_pct, t.series, undefined, TYPE_MONO[t.key] || 'IX'));
      });
    } else {
      /* biggest baskets first, the order the page's snapshot prints (track_sync write_hub), so the
         rows don't reshuffle when the script takes over */
      var sets = (lastIdx.sets || []).filter(function (s) { return s.level != null; })
        .map(function (s, i) { return { s: s, i: i }; })
        .sort(function (a, b) { return (b.s.count || 0) - (a.s.count || 0) || a.i - b.i; })
        .map(function (x) { return x.s; });
      sets.forEach(function (s) {
        rows.push(ixRow('set:' + s.set_name, setLabel(s.set_name) + ((SET_INFO[s.set_name] || {}).lang === 'JP' ? ' (Japanese)' : ''),
          (s.covered != null ? s.covered : s.count) + ' products', s.level, s.change_pct, s.series, s.set_name));
      });
    }
    var limit = ixKind === 'sets' && !ixAllOpen ? IX_ROWS : rows.length;
    rows.slice(0, limit).forEach(function (r) { ixList.appendChild(r); });
    if (ixMore) {
      ixMore.hidden = ixKind !== 'sets' || rows.length <= IX_ROWS;
      ixMore.textContent = ixAllOpen ? 'Show fewer' : 'All ' + rows.length + ' set indexes';
      ixMore.setAttribute('aria-expanded', ixAllOpen ? 'true' : 'false');
    }
  }

  /* ---------- the hub's own Track bar menus: Products · Indices · Singles · International ----------
     Built from the catalogue on each open (Sets is the server-rendered menu in track-nav.js). */
  var openTab = null;
  function navSync() {
    if (megaNavEl) {
      megaNavEl.querySelectorAll('.qpt-mntab[data-tab]').forEach(function (b) {
        var key = b.getAttribute('data-tab');
        var on = (key === 'singles' && mode === 'singles') || (key === 'intl' && activeEra === 'International');
        if (on) b.setAttribute('data-active', ''); else b.removeAttribute('data-active');
      });
    }
    if (mktEl) {
      mktEl.querySelectorAll('[data-mkt]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-mkt') === mode ? 'true' : 'false');
      });
    }
  }
  function closePanel() {
    if (!panelEl || !openTab) return;
    panelEl.hidden = true;
    panelEl.textContent = '';
    openTab = null;
    megaNavEl.querySelectorAll('.qpt-mntab[data-tab]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  function panelGroup(title) {
    var g = el('div', 'qpt-panelgroup');
    if (title) g.appendChild(el('h3', 'qpt-panelgroup-h', title));
    return g;
  }
  function panelLink(label, count, nav, arg, extra) {
    var a = document.createElement('a');
    a.className = 'qpt-panellink';
    a.href = '?' + (nav === 'index' ? 'index=' + encodeURIComponent(arg)
      : nav === 'ptype' ? 'ptype=' + encodeURIComponent(arg)
      : nav === 'era' ? 'era=' + encodeURIComponent(arg)
      : nav === 'set' ? 'set=' + encodeURIComponent(arg) : '');
    a.setAttribute('data-mnav', nav);
    if (arg != null) a.setAttribute('data-arg', arg);
    if (extra && extra.market) { a.setAttribute('data-market', extra.market); if (extra.market === 'singles') a.href = '?market=singles&set=' + encodeURIComponent(arg); }
    if (extra && extra.logo) { var lg = setLogo(arg, 18); if (lg) a.appendChild(lg); }
    a.appendChild(el('span', 'qpt-panellink-t', label));
    if (count != null) a.appendChild(el('span', 'qpt-panellink-n', String(count)));
    return a;
  }
  function panelFoot(label, nav, arg) {
    var a = document.createElement('a');
    a.className = 'qpt-seeall qpt-panelfoot-a';
    a.href = nav === 'anchor' ? '#' + arg : '?';
    a.setAttribute('data-mnav', nav);
    if (arg != null) a.setAttribute('data-arg', arg);
    a.textContent = label;
    return a;
  }
  function setCount(name) {
    var s = SET_INFO[name] || {};
    return mode === 'singles' ? s.singles : s.sealed;
  }
  var PANEL_BUILDERS = {
    /* sealed product types, plus movers */
    products: function (frame) {
      var counts = {};
      products.forEach(function (p) { var k = ptypeOf(p); if (k) counts[k] = (counts[k] || 0) + 1; });
      var g = panelGroup('Shop by product type');
      // alphabetical for display — PTYPES itself stays in classification
      // priority order (UPC must match before Collection)
      PTYPES.slice().sort(function (a, b) { return a.label.localeCompare(b.label); }).forEach(function (t) {
        if (counts[t.key]) g.appendChild(panelLink(t.label, counts[t.key], 'ptype', t.key));
      });
      g.appendChild(panelLink('All sealed products', products.filter(function (p) { return p.type !== 'single'; }).length, 'ptype', ''));
      frame.appendChild(g);
      frame.appendChild(panelFoot('Top movers', 'anchor', 'qpt-movers'));
    },

    /* every index gets a page — flagship, product types, then sets newest first */
    indices: function (frame) {
      var g1 = panelGroup('Market index');
      g1.appendChild(panelLink('Quaza Index', null, 'index', 'quaza'));
      frame.appendChild(g1);
      var g2 = panelGroup('Product indexes');
      [['booster-box', 'Booster Box Index'], ['booster-bundle', 'Booster Bundle Index'],
       ['collection', 'Collection Box Index'], ['etb', 'Elite Trainer Box Index'],
       ['upc', 'Ultra-Premium Collection Index']]
        .forEach(function (t) { g2.appendChild(panelLink(t[1], null, 'index', t[0])); });
      frame.appendChild(g2);
      var g3 = panelGroup('Set indexes');
      var names = lastIdx && lastIdx.sets
        ? lastIdx.sets.map(function (s) { return s.set_name; })
        : setsFor(null).filter(function (n) { return (SET_INFO[n] || {}).sealed > 0; });
      // English sets only (owner call) — JP sets stay reachable via International
      names = names.filter(function (n) { return (SET_INFO[n] || {}).lang === 'EN'; });
      names.sort(function (a, b) {
        // newest first; the misc catch-all bucket always sinks to the bottom
        var ma = a === MISC_SET ? 1 : 0, mb = b === MISC_SET ? 1 : 0;
        if (ma !== mb) return ma - mb;
        return setRel(a) < setRel(b) ? 1 : -1;
      });
      names.forEach(function (name) {
        /* Deliberately text-only: the owner does not want set logos in the
           Indices panel (decided 2026-07-30). It never rendered one anyway, as
           the nav arg is prefixed with "set:" and so never matches a set_logos
           key. The flag is removed rather than left inert, so that correcting
           the key later cannot silently switch 40 logos on. */
        g3.appendChild(panelLink(setLabel(name), null, 'index', 'set:' + name));
      });
      frame.appendChild(g3);
    },

    /* switches the whole page to the singles market */
    singles: function (frame) {
      var g0 = panelGroup(null);
      var all = products.filter(function (p) { return p.type === 'single'; }).length;
      g0.appendChild(panelLink('All single cards', all, 'singles-all', ''));
      frame.appendChild(g0);
      var eras = [];
      products.forEach(function (p) {
        var l = eraOf(p);
        if (p.type !== 'single' || l === 'International' || eras.indexOf(l) !== -1) return;
        eras.push(l);
      });
      eras.sort(function (a, b) { return (ERA_RANK[a] || 0) - (ERA_RANK[b] || 0); });
      eras.forEach(function (era) {
        var g = panelGroup(eraLabel(era));
        var seen = {};
        products.forEach(function (p) {
          if (p.type !== 'single' || eraOf(p) !== era || seen[p.set_name]) return;
          seen[p.set_name] = 1;
        });
        Object.keys(seen).sort(function (a, b) { return setRel(a) < setRel(b) ? 1 : -1; })
          .forEach(function (name) {
            g.appendChild(panelLink(name, (SET_INFO[name] || {}).singles, 'set', name, { logo: 1, market: 'singles' }));
          });
        frame.appendChild(g);
      });
    },

    /* Japanese (and future non-EN) sets — sealed and singles kept apart */
    intl: function (frame) {
      var sealed = {}, singles = {};
      products.forEach(function (p) {
        if (eraOf(p) !== 'International') return;
        (p.type === 'single' ? singles : sealed)[p.set_name] = 1;
      });
      function fill(title, names, market) {
        if (!names.length) return;
        var g = panelGroup(title);
        names.sort(function (a, b) { return setRel(a) < setRel(b) ? 1 : -1; })
          .forEach(function (name) {
            var info = SET_INFO[name] || {};
            g.appendChild(panelLink(name, market === 'singles' ? info.singles : info.sealed, 'set', name,
              market === 'singles' ? { market: 'singles' } : { logo: 1 }));
          });
        frame.appendChild(g);
      }
      fill('Japanese · Sealed', Object.keys(sealed), 'sealed');
      fill('Japanese · Singles', Object.keys(singles), 'singles');
      frame.appendChild(panelFoot('All Japanese products', 'era', 'International'));
    }
  };

  function openPanel(key) {
    if (!panelEl) return;
    panelEl.textContent = '';
    var frame = el('div', 'page-width qpt-panel-in');
    if (!products.length) frame.appendChild(el('div', 'qpt-status', 'Loading market data…'));
    else PANEL_BUILDERS[key](frame);
    panelEl.appendChild(frame);
    panelEl.hidden = false;
    openTab = key;
    megaNavEl.querySelectorAll('.qpt-mntab[data-tab]').forEach(function (b) {
      b.setAttribute('aria-expanded', b.getAttribute('data-tab') === key ? 'true' : 'false');
    });
    root.dispatchEvent(new CustomEvent('qpt:menu', { detail: { open: key } }));
  }
  function handlePanelLink(a) {
    var nav = a.getAttribute('data-mnav');
    var arg = a.getAttribute('data-arg') || '';
    var market = a.getAttribute('data-market');
    closePanel();
    if (nav === 'index') { navigateToIndex(arg); return; }
    if (root.getAttribute('data-view') !== 'market') {
      var u = new URL(location.href);
      u.searchParams.delete('product');
      u.searchParams.delete('index');
      history.pushState({}, '', u);
      showMarket();
    }
    if (nav === 'set') {
      setMode(market === 'singles' ? 'singles' : 'sealed', true);
      applySet(arg, { scroll: true });
    } else if (nav === 'era') {
      applyEra(arg, { scroll: true });
    } else if (nav === 'ptype') {
      setMode('sealed', true);
      applyType(arg || null, { scroll: true });
    } else if (nav === 'singles-all') {
      setMode('singles');
      scrollToMarket();
    } else if (nav === 'browse-all') {
      applyType(null, { scroll: true });
    } else if (nav === 'anchor') {
      var t = document.getElementById(arg);
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  if (megaNavEl) {
    megaNavEl.addEventListener('click', function (ev) {
      var tab = ev.target.closest('[data-tab]');
      if (tab) {
        var key = tab.getAttribute('data-tab');
        if (openTab === key) { closePanel(); return; }
        // Singles switches the whole market; the sealed menus switch it back
        if (key === 'singles') setMode('singles', true);
        if (key === 'products' || key === 'indices') setMode('sealed', true);
        openPanel(key);
        return;
      }
      var a = ev.target.closest('a[data-mnav]');
      if (a && panelEl.contains(a)) { ev.preventDefault(); handlePanelLink(a); }
    });
    document.addEventListener('click', function (ev) {
      if (!openTab) return;
      var nav = window.QuazaTrackNav; // reads the click's path, so a redrawn target still counts as inside
      if (nav && nav.within ? !nav.within(ev, megaNavEl) : !megaNavEl.contains(ev.target)) closePanel();
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && openTab) {
        var t = megaNavEl.querySelector('.qpt-mntab[data-tab="' + openTab + '"]');
        closePanel();
        if (t) t.focus();
      }
    });
    root.addEventListener('qpt:menu', function (ev) { if (ev.detail && ev.detail.open === 'sets') closePanel(); });
  }

  /* ---------- product and index views ---------- */
  /* the way back to the market, at the top of every product and index view */
  function trackerHomeBtn() {
    var b = el('a', 'qpt-back');
    b.href = location.pathname;
    b.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 3.5 5.5 8l4.5 4.5"/></svg><span>Quaza Track market</span>';
    b.addEventListener('click', function (ev) {
      if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button) return;
      ev.preventDefault();
      if (history.state && history.state.fromMarket) { history.back(); return; }
      var u = new URL(location.href);
      u.searchParams.delete('product');
      u.searchParams.delete('index');
      history.pushState({}, '', u);
      showMarket();
      window.scrollTo(0, 0);
    });
    return b;
  }
  function relatedHeading(text) { return el('h2', 'qpt-pv-relhead', text); }
  /* The app's download block on product and index views too: a copy of the one the page prints
     (snippets/track-app-strip.liquid), with its own App Store campaign so each placement counts. */
  var appStripSrc = root.querySelector('.qpt-top > .qpt-appstrip');
  function appStrip(ct, cls) {
    if (!appStripSrc) return null;
    var n = appStripSrc.cloneNode(true);
    var qr = n.querySelector('.qpt-appstrip-qr'); // the header's QR code stays the header's
    if (qr) qr.parentNode.removeChild(qr);
    n.classList.remove('qpt-appstrip--qr');
    var h = n.querySelector('.qpt-appstrip-h');
    if (h) { h.id = 'qpt-appstrip-h-' + ct + (cls ? '-' + cls : ''); n.setAttribute('aria-labelledby', h.id); }
    var a = n.querySelector('.qpt-appstrip-badge');
    if (a) a.href = a.href.replace(/([?&]ct=)[^&]*/, '$1' + ct);
    if (cls) n.className += ' ' + cls;
    return n;
  }

  function sanitizeStoreHtml(html) {
    var doc = new DOMParser().parseFromString(html || '', 'text/html');
    var bad = doc.querySelectorAll('script, style, iframe, object, embed, link, form');
    for (var i = 0; i < bad.length; i++) bad[i].parentNode.removeChild(bad[i]);
    var all = doc.querySelectorAll('*');
    for (var j = 0; j < all.length; j++) {
      var attrs = all[j].attributes;
      for (var k = attrs.length - 1; k >= 0; k--) {
        var name = attrs[k].name.toLowerCase();
        var val = String(attrs[k].value || '');
        if (name.indexOf('on') === 0 || (name === 'href' || name === 'src') && val.trim().toLowerCase().indexOf('javascript:') === 0) {
          all[j].removeAttribute(attrs[k].name);
        }
      }
    }
    return doc.body.innerHTML;
  }

  function statTile(label, value, cls) {
    var t = el('div', 'qpt-pv-stat');
    t.appendChild(el('p', 'l', label));
    t.appendChild(el('p', 'v' + (cls ? ' ' + cls : ''), value));
    return t;
  }

  /* Store prices from Shopify's localized endpoints (/products/<h>.js,
     /recommendations/products.json, /collections/<h>/products.json) are ALREADY in the visitor's selected store
     currency — format them as-is with Shopify's active currency code. Never run
     them through fmtCAD: that applies the tracker's market-FX rate on top and
     double-converts (the Pitch Black PC ETB bug). Market prices keep fmtCAD. */
  function fmtStorePrice(cents) {
    if (cents == null) return '';
    var code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD';
    try {
      return new Intl.NumberFormat('en', { style: 'currency', currency: code }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* Native add-to-cart: same /cart/add.js + ajaxProduct:added flow as the theme's
     product forms, so the site's cart drawer opens and the header count updates. */
  function addToCart(variantId, btn) {
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var original = btn.textContent;
    btn.disabled = true;
    btn.classList.add('btn--loading');
    fetch(rootPath + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        btn.classList.remove('btn--loading');
        btn.disabled = false;
        if (!res.ok || res.d.status === 422) {
          btn.textContent = 'Sold Out';
          setTimeout(function () { btn.textContent = original; }, 2500);
          return;
        }
        if (window.theme && window.theme.settings && window.theme.settings.cartType === 'page' &&
            window.theme.routes && window.theme.routes.cartPage) {
          window.location = window.theme.routes.cartPage;
          return;
        }
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        btn.textContent = 'Added ✓';
        setTimeout(function () { btn.textContent = original; }, 2000);
      })
      .catch(function () {
        btn.classList.remove('btn--loading');
        btn.disabled = false;
        btn.textContent = original;
      });
  }

  /* Our graded copies of a card (shop track.store "graded": Track id -> our active slabs, written by track_sync).
     A slab is never in by_tcg, so it never sells as the raw card next to the raw card's market price. Owner, 2026-10-21
     (change 5, mock M2): our price and stock only, never a third-party graded price, and the market card says its
     price is the ungraded one. Each copy shows once the store serves it; a drafted or unpublished slab shows nothing. */
  function markUngraded(marketCard) {
    var label = marketCard.querySelector('.qpt-pv-cardlabel');
    if (label && label.textContent === 'Market data') label.textContent = 'Market data · ungraded';
    Array.prototype.forEach.call(marketCard.querySelectorAll('.qpt-pv-stock'), function (n) {
      if (n.textContent === 'Not currently sold at Quaza Collect') n.remove();
    });
  }
  function renderGradedCard(side, marketCard, p, entries) {
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var gcard = el('div', 'qpt-pv-card qpt-pv-gcard');
    gcard.hidden = true;
    gcard.appendChild(el('p', 'qpt-pv-cardlabel', entries.length > 1 ? 'Graded copies at Quaza Collect' : 'Graded copy at Quaza Collect'));
    side.appendChild(gcard);
    // The printing goes on the line only when the raw card has more than one (Pidgeot: 1st Edition and Unlimited)
    var printings = (p._cov && p._cov.variants) || [];
    entries.forEach(function (g) {
      var url = rootPath + 'products/' + encodeURIComponent(g.h);
      var grade = [g.by, g.g].filter(Boolean).join(' ');
      var item = el('div', 'qpt-pv-gentry');
      item.hidden = true;
      gcard.appendChild(item);
      fetch(url + '.js')
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
        .then(function (sp) {
          var a = el('a', 'qpt-pv-gitem');
          a.href = url;
          if (sp.featured_image) {
            var src = String(sp.featured_image), q = src.indexOf('?') < 0 ? '?' : '&';
            var im = document.createElement('img');
            im.alt = p.name + ' in ' + grade + ' slab';
            im.width = 52; im.height = 87;
            im.decoding = 'async';
            im.sizes = '52px';
            im.srcset = src + q + 'width=104 104w, ' + src + q + 'width=156 156w';
            im.src = src + q + 'width=104';
            a.appendChild(im);
          }
          var txt = el('div');
          txt.appendChild(el('p', 'qpt-pv-gname', grade + (g.n ? ' ' + g.n : '') + (printings.length > 1 && g.pr ? ' · ' + g.pr : '')));
          if (g.c) txt.appendChild(el('p', 'qpt-pv-gcert', 'Cert ' + g.c));
          // The theme's own money format, as the set page prints the same price ("$349.99", mock M2)
          var money = window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat
            ? theme.Currency.formatMoney(sp.price, theme.settings.moneyFormat) : fmtStorePrice(sp.price);
          txt.appendChild(el('p', 'qpt-pv-storeprice', money));
          txt.appendChild(el('p', 'qpt-pv-stock ' + (sp.available ? 'in' : 'out'), sp.available ? 'In stock' : 'Sold out'));
          a.appendChild(txt);
          item.appendChild(a);
          var ctaWrap = el('div');
          var cta = el('a', 'btn qpt-cta', 'View the ' + grade);
          cta.href = url;
          ctaWrap.appendChild(cta);
          item.appendChild(ctaWrap);
          item.hidden = false;
          gcard.hidden = false;
          p._gradedShown = true;
          markUngraded(marketCard);
        })
        .catch(function () { item.remove(); });
    });
  }

  function renderProductView(p) {
    var sh = storeHandleFor(p);
    if (sh) p.shopify_handle = sh;
    productEl.textContent = '';
    productEl.appendChild(trackerHomeBtn());

    var grid = el('div', 'qpt-pv');
    var main = el('div');
    var side = el('div', 'qpt-pv-side');
    grid.appendChild(main);
    grid.appendChild(side);
    productEl.appendChild(grid);

    // main column — product identity header (image first: this is what you're tracking)
    var head = el('div', 'qpt-pv-head');
    var headImg = el('div', 'qpt-pv-headimg');
    headImg.appendChild(img(p.image_url, p.name, 96));
    head.appendChild(headImg);
    var headTxt = el('div');
    var h1 = el('h1', 'qpt-pv-name', p.name);
    h1.tabIndex = -1;
    headTxt.appendChild(h1);
    headTxt.appendChild(el('p', 'qpt-pv-meta', metaLine(p)));
    head.appendChild(headTxt);
    main.appendChild(head);

    var chartCard = el('div', 'qpt-pv-chartcard');
    var chartMount = el('div');
    chartCard.appendChild(chartMount);
    main.appendChild(chartCard);

    var statRow = el('div', 'qpt-pv-statrow');
    main.appendChild(statRow);
    if (p._cov) {
      // the same flags the app and the set pages show: an old price is not today's market
      var lc = p._cov.last_change;
      if (lc && (Date.now() - Date.parse(lc + 'T00:00:00Z')) / 86400e3 >= 30) {
        main.appendChild(el('p', 'qpt-pv-note', 'No price change since ' +
          new Date(lc + 'T12:00:00Z').toLocaleDateString('en-CA', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' }) +
          ': this is the last recorded price, not a recent sale.'));
      } else if (p._cov.thin) {
        main.appendChild(el('p', 'qpt-pv-note', 'Few sellers: this price rests on one or two listings.'));
      }
    }
    function paintStats(detail) {
      statRow.textContent = '';
      statRow.appendChild(statTile('Market price', C.fmtCAD(detail.current_cents)));
      if (p.change7d_pct != null) {
        statRow.appendChild(statTile('7-day change',
          (p.change7d_pct >= 0 ? '+' : '−') + Math.abs(p.change7d_pct) + '%',
          p.change7d_pct >= 0 ? 'qpt-up' : 'qpt-down'));
      } else {
        var rc = detail.change_pct;
        statRow.appendChild(statTile('Range change',
          rc == null ? '–' : (rc >= 0 ? '+' : '−') + Math.abs(rc) + '%',
          rc == null ? null : rc >= 0 ? 'qpt-up' : 'qpt-down'));
      }
      statRow.appendChild(statTile('Range high', C.fmtCAD(detail.high_cents)));
      statRow.appendChild(statTile('Range low', C.fmtCAD(detail.low_cents)));
      // always six tiles so the grid stays uniform (2×3 mobile, 3×2 up)
      if (p._cov) {
        var h = p._cov;
        statRow.appendChild(h.kind === 'card'
          ? statTile(h.printing ? 'Printing' : 'Card number', h.printing || (h.number ? '#' + h.number : '–'))
          : statTile('Tracked since', new Date(h.start + 'T12:00:00Z').toLocaleDateString('en-CA', { month: 'short', year: 'numeric', timeZone: 'UTC' })));
        var crel = p._set && p._set.release;
        statRow.appendChild(statTile('Released', crel
          ? new Date(crel + 'T12:00:00Z').toLocaleDateString('en-CA', { month: 'short', year: 'numeric', timeZone: 'UTC' })
          : '–'));
        return;
      }
      // set rank = price position among same-type products of the set
      var peers = products.filter(function (o) {
        return o.set_name === p.set_name && (o.type === 'single') === (p.type === 'single') && o.price_cents != null;
      }).sort(function (a, b) { return b.price_cents - a.price_cents; });
      var rank = -1;
      peers.forEach(function (o, i) { if (o.id === p.id) rank = i; });
      statRow.appendChild(statTile('Set rank', rank >= 0 ? '#' + (rank + 1) + ' of ' + peers.length : '–'));
      var rel = setRel(p.set_name);
      statRow.appendChild(statTile('Released', rel
        ? new Date(rel + 'T12:00:00Z').toLocaleDateString('en-CA', { month: 'short', year: 'numeric', timeZone: 'UTC' })
        : '–'));
    }

    var pvAppM = appStrip('track-product', 'qpt-pv-app--m');
    if (pvAppM) main.appendChild(pvAppM);
    var descWrap = el('div', 'qpt-pv-desc');
    main.appendChild(descWrap);

    // bottom: related rows (same-set tracker products + store shop slider)
    var related = el('div', 'qpt-pv-related');
    productEl.appendChild(related);
    renderSameSetRow(p, related);
    var shopMount = el('div');
    related.appendChild(shopMount);

    // side column — buy/store card
    var card = el('div', 'qpt-pv-card');
    side.appendChild(card);
    var graded = p._tcg != null ? (storeMap.graded || {})[p._tcg] : null;
    if (graded && graded.length) renderGradedCard(side, card, p, graded);
    var pvApp = appStrip('track-product', 'qpt-pv-app');
    if (pvApp) side.appendChild(pvApp);

    if (p.shopify_handle) {
      card.appendChild(el('p', 'qpt-pv-cardlabel', 'At Quaza Collect'));
      var priceP = el('p', 'qpt-pv-storeprice', '…');
      var stockP = el('p', 'qpt-pv-stock', '');
      card.appendChild(priceP);
      card.appendChild(stockP);
      var ctaWrap = el('div');
      card.appendChild(ctaWrap);
      var cta = el('a', 'btn qpt-cta', 'Buy at Quaza Collect');
      var productUrl = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') +
        'products/' + encodeURIComponent(p.shopify_handle);
      cta.href = productUrl;
      ctaWrap.appendChild(cta);

      // enrich from the store's public product JSON (same-origin, no tokens)
      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(rootPath + 'products/' + encodeURIComponent(p.shopify_handle) + '.js')
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
        .then(function (sp) {
          priceP.textContent = fmtStorePrice(sp.price);
          stockP.textContent = sp.available ? 'In stock' : 'Sold out';
          stockP.className = 'qpt-pv-stock ' + (sp.available ? 'in' : 'out');
          if (sp.variants && sp.variants.length === 1 && sp.variants[0].available) {
            // single-variant in-stock: real add-to-cart, right here — the theme's
            // cart drawer takes over after the add, same as any PDP
            ctaWrap.textContent = '';
            var addBtn = el('button', 'btn qpt-cta', 'Add to Cart');
            addBtn.type = 'button';
            addBtn.addEventListener('click', function () { addToCart(sp.variants[0].id, addBtn); });
            ctaWrap.appendChild(addBtn);
            var view = el('a', 'qpt-cta-view', 'View the full listing');
            view.href = productUrl;
            ctaWrap.appendChild(view);
          } else if (!sp.available) {
            cta.textContent = 'View at Quaza Collect';
          }
          if (sp.description) {
            descWrap.appendChild(el('h3', null, 'About this product'));
            var body = el('div', 'qpt-pv-desc-body');
            body.innerHTML = sanitizeStoreHtml(sp.description);
            descWrap.appendChild(body);
          }
          renderShopSlider(shopMount, p, sp.id);
        })
        .catch(function () {
          // The tracker knows this handle but the storefront won't serve it:
          // the listing has been drafted, unpublished or removed. Track still
          // shows the market data, but the buy button has to go — otherwise it
          // sends people to a 404.
          var label = card.querySelector('.qpt-pv-cardlabel');
          if (label) label.textContent = 'Market data';
          priceP.textContent = C.fmtCAD(p.price_cents);
          stockP.textContent = 'Not currently sold at Quaza Collect';
          stockP.className = 'qpt-pv-stock out';
          ctaWrap.textContent = '';
          if (p._gradedShown) markUngraded(card);
          renderShopSlider(shopMount, p, null);
        });
    } else {
      card.appendChild(el('p', 'qpt-pv-cardlabel', 'Market data'));
      card.appendChild(el('p', 'qpt-pv-storeprice', C.fmtCAD(p.price_cents)));
      var note = el('p', 'qpt-pv-stock', 'Not currently sold at Quaza Collect');
      card.appendChild(note);
      renderShopSlider(shopMount, p, null);
    }
    card.appendChild(el('p', 'qpt-pv-note',
      'Market price, quoted in CAD' +
      (C.moneyCode() !== 'CAD' ? ', shown in ' + C.moneyCode() : '') +
      ', updated daily. ' + updatedAtText +
      'Quaza Collect pricing and availability may differ.'));

    widget = C.renderWidget(chartMount, {
      load: p._load || function (r) { return D.product(p.id, r); },
      range: '3m',
      onDetail: paintStats
    });

    document.title = p.name + ' price | ' + baseTitle;
    window.scrollTo(0, 0);
    h1.focus({ preventScroll: true });
  }

  /* ---------- product view: related rows ---------- */

  function renderSameSetRow(p, mount) {
    if (p._cov) {
      var url = p._set && setPageUrl(p._set.id);
      if (!url) return;
      var a = el('a', 'qpt-btn qpt-btn--primary qpt-pv-setlink', 'Every ' + p.set_name + ' price');
      a.href = url;
      mount.appendChild(a);
      return;
    }
    var same = products.filter(function (o) {
      return o.set_name === p.set_name && o.id !== p.id;
    }).slice(0, 10);
    if (!same.length) return;
    mount.appendChild(relatedHeading('More in ' + (setLabel(p.set_name) || 'this set')));
    var row = el('div', 'qpt-shop-row');
    same.forEach(function (o) { row.appendChild(productCard(o, { grouped: true })); });
    mount.appendChild(row);
  }

  /* Store slider: Shopify's related-products API when this product is in the store,
     otherwise the configured collection — both public same-origin JSON. */
  function renderShopSlider(mount, p, storeProductId) {
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var collection = root.getAttribute('data-shop-collection') || 'sealed-pokemon';
    var heading = root.getAttribute('data-shop-heading') || 'Shop at Quaza Collect';

    // /products/<h>.js format: price in cents, featured_image
    function fromJsFormat(list) {
      return list.map(function (sp) {
        return { title: sp.title, handle: sp.handle, cents: sp.price, store: true, image: sp.featured_image, available: sp.available };
      });
    }
    // /collections/<h>/products.json format: price as "379.99" string, images array
    function fromRestFormat(list) {
      return list.map(function (sp) {
        var v = (sp.variants && sp.variants[0]) || {};
        return {
          title: sp.title, handle: sp.handle,
          cents: v.price != null ? Math.round(parseFloat(v.price) * 100) : null, store: true,
          image: (sp.images && sp.images[0] && sp.images[0].src) || null,
          available: v.available !== false
        };
      });
    }

    function paint(items) {
      items = items.filter(function (it) { return it.handle !== p.shopify_handle; }).slice(0, 8);
      if (!items.length) return;
      mount.appendChild(relatedHeading(heading));
      var row = el('div', 'qpt-shop-row');
      items.forEach(function (it) {
        var a = el('a', 'qpt-shopcard');
        a.href = rootPath + 'products/' + encodeURIComponent(it.handle);
        var im = el('div', 'qpt-shopcard-img');
        im.appendChild(img(it.image, it.title, 160));
        a.appendChild(im);
        a.appendChild(el('p', 'qpt-shopcard-name', it.title));
        var foot = el('div');
        foot.appendChild(el('span', 'qpt-shopcard-price', it.cents != null ? (it.store ? fmtStorePrice(it.cents) : C.fmtCAD(it.cents)) : ''));
        if (it.available === false) foot.appendChild(el('span', 'qpt-shopcard-badge out', 'Sold out'));
        a.appendChild(foot);
        row.appendChild(a);
      });
      mount.appendChild(row);
    }

    function fromCollection() {
      fetch(rootPath + 'collections/' + encodeURIComponent(collection) + '/products.json?limit=9')
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
        .then(function (data) { paint(fromRestFormat(data.products || [])); })
        .catch(function () { /* no slider — never break the page over suggestions */ });
    }

    /* A tracked card or box: our in-stock sealed products from its own set first (shop track.store "by_set",
       written by track_sync, track-20261021-4), so a Prismatic Evolutions card shows Prismatic Evolutions boxes.
       Each one shows once the store serves it; a set with none keeps the rows below. */
    var own = p._set && p._set.id != null ? (storeMap.by_set || {})[p._set.id] : null;
    own = (own || []).filter(function (h) { return h !== p.shopify_handle; }).slice(0, 8);
    if (own.length) {
      Promise.all(own.map(function (h) {
        return fetch(rootPath + 'products/' + encodeURIComponent(h) + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (list) {
        var items = fromJsFormat(list.filter(function (sp) { return sp && sp.available; }));
        if (items.length) { heading = 'Shop ' + p.set_name + ' at Quaza Collect'; paint(items); }
        else others();
      });
    } else {
      others();
    }

    function others() {
      if (storeProductId) fromRecommendations();
      else fromCollection();
    }
    function fromRecommendations() {
      fetch(rootPath + 'recommendations/products.json?product_id=' + storeProductId + '&limit=8')
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
        .then(function (data) {
          var items = fromJsFormat(data.products || []);
          if (items.length >= 2) paint(items);
          else fromCollection();
        })
        .catch(fromCollection);
    }
  }


  /* ---------- index views ---------- */
  function resolveIndex(key, src) {
    var data = src || lastIdx;
    if (!data) return null;
    if (key === 'quaza') {
      var o = data.overall || {};
      var members;
      if (o.curated && o.ids) {
        var m = {};
        (o.ids || []).forEach(function (id) { m[id] = 1; });
        members = products.filter(function (p) { return m[p.id]; });
      } else {
        members = products.filter(function (p) { return p.type !== 'single'; });
      }
      return { key: key, name: o.name || 'Quaza Index', sub: o.curated ? 'Curated flagship index' : 'The whole sealed market, equal-weight',
        count: o.count, level: o.level, change_pct: o.change_pct, series: o.series, members: members };
    }
    var t = (data.types || []).filter(function (x) { return x.key === key; })[0];
    if (t) {
      var tm = {};
      (t.ids || []).forEach(function (id) { tm[id] = 1; });
      return { key: key, name: t.name + ' Index', sub: 'Every tracked ' + t.name.toLowerCase() + ', across all sets',
        count: t.count, level: t.level, change_pct: t.change_pct, series: t.series,
        members: products.filter(function (p) { return tm[p.id]; }) };
    }
    if (key.indexOf('set:') === 0) {
      var name = key.slice(4);
      var s = (data.sets || []).filter(function (x) { return x.set_name === name; })[0];
      if (s) {
        return { key: key, name: setLabel(s.set_name), sub: 'Set index · sealed products only', setName: s.set_name,
          count: s.count, level: s.level, change_pct: s.change_pct, series: s.series,
          members: products.filter(function (p) { return p.set_name === s.set_name && p.type !== 'single'; }) };
      }
    }
    return null;
  }

  function renderIndexPage(ix) {
    productEl.textContent = '';
    productEl.appendChild(trackerHomeBtn());

    var head = el('div', 'qpt-pv-head');
    if (ix.setName) {
      var lg = setLogo(ix.setName, 44);
      if (lg) {
        var lgWrap = el('div', 'qpt-ix-headlogo');
        lgWrap.appendChild(lg);
        head.appendChild(lgWrap);
      }
    }
    var headTxt = el('div');
    var h1 = el('h1', 'qpt-pv-name', ix.name);
    h1.tabIndex = -1;
    headTxt.appendChild(h1);
    headTxt.appendChild(el('p', 'qpt-pv-meta', ix.sub + ' · ' + ix.count + ' products · 100 means launch price'));
    head.appendChild(headTxt);
    productEl.appendChild(head);

    C.injectCSS(); // the range pills reuse the chart widget's qpc-pill styles

    var IDXR = [['1w', '1W'], ['1m', '1M'], ['3m', '3M'], ['6m', '6M'], ['max', 'MAX']];
    var IDXR_TEXT = { '1w': 'past week', '1m': 'past month', '3m': 'past 3 months', '6m': 'past 6 months', 'max': 'all time' };
    var IDXR_LABEL = { '1w': '1-week change', '1m': '1-month change', '3m': '3-month change', '6m': '6-month change', 'max': 'All-time change' };
    var curRange = '3m';
    var cur = ix; // the resolved index for the active range

    var chartCard = el('div', 'qpt-pv-chartcard');
    var valRow = el('div', 'qpt-idx-valrow');
    var valEl = el('span', 'qpt-idx-value', fmtPts(ix.level));
    valRow.appendChild(valEl);
    valRow.appendChild(el('span', 'qpt-idx-unit', 'PTS'));
    var chipEl = chgText(ix.change_pct);
    valRow.appendChild(chipEl);
    var scrubDate = el('span', 'qpt-ix-scrubdate', IDXR_TEXT[curRange]);
    valRow.appendChild(scrubDate);
    chartCard.appendChild(valRow);
    var chart = el('div', 'qpt-idx-chart');
    chartCard.appendChild(chart);
    var ranges = el('div', 'qpc-ranges');
    ranges.setAttribute('role', 'radiogroup');
    ranges.setAttribute('aria-label', 'Index history range');
    IDXR.forEach(function (r) {
      var b = el('button', 'qpc-pill', r[1]);
      b.type = 'button';
      b.setAttribute('role', 'radio');
      b.setAttribute('data-range', r[0]);
      b.setAttribute('aria-checked', r[0] === curRange ? 'true' : 'false');
      b.addEventListener('click', function () { setRange(r[0]); });
      ranges.appendChild(b);
    });
    chartCard.appendChild(ranges);
    productEl.appendChild(chartCard);

    // six tiles, always, matching the product view's uniform grid; the first
    // two follow the selected range, the rest are range-independent
    var statRow = el('div', 'qpt-pv-statrow');
    productEl.appendChild(statRow);
    function paintIdxStats() {
      statRow.textContent = '';
      statRow.appendChild(statTile('Index level', fmtPts(cur.level)));
      statRow.appendChild(statTile(IDXR_LABEL[curRange],
        cur.change_pct == null ? '–' : (cur.change_pct >= 0 ? '+' : '−') + Math.abs(cur.change_pct) + '%',
        cur.change_pct == null ? null : cur.change_pct >= 0 ? 'qpt-up' : 'qpt-down'));
      statRow.appendChild(statTile('Products', String(ix.count)));
      // basket value: what one of everything in this index costs today
      var basket = 0;
      ix.members.forEach(function (p) { if (p.price_cents != null) basket += p.price_cents; });
      statRow.appendChild(statTile('Basket value', basket ? C.fmtCAD(basket) : '–'));
      var movers7 = ix.members.filter(function (p) { return p.change7d_pct != null; })
        .sort(function (a, b) { return b.change7d_pct - a.change7d_pct; });
      var best = movers7[0];
      statRow.appendChild(statTile('Top gainer · 7d',
        best ? (best.change7d_pct >= 0 ? '+' : '−') + Math.abs(best.change7d_pct) + '%' : '–',
        best && best.change7d_pct >= 0 ? 'qpt-up' : best ? 'qpt-down' : null));
      var up7 = 0, down7 = 0;
      movers7.forEach(function (p) {
        if (p.change7d_pct > 0) up7++; else if (p.change7d_pct < 0) down7++;
      });
      statRow.appendChild(statTile('Rising / falling · 7d', movers7.length ? up7 + ' ▲ · ' + down7 + ' ▼' : '–'));
    }
    paintIdxStats();
    var ixApp = appStrip('track-index', 'qpt-ix-app');
    if (ixApp) productEl.appendChild(ixApp);

    function drawIdx() {
      C.drawChart(chart, cur.series || [], (cur.change_pct || 0) >= 0, {
        fmt: fmtPts,
        guides: false,
        onScrub: function (pt) {
          if (!pt) {
            valEl.textContent = fmtPts(cur.level);
            scrubDate.textContent = IDXR_TEXT[curRange];
            chipEl.replaceWith(chipEl = chgText(cur.change_pct));
            return;
          }
          valEl.textContent = fmtPts(pt.value);
          scrubDate.textContent = C.fmtDate(pt.date);
          var d = pt.first > 0 ? Math.round(((pt.value - pt.first) / pt.first) * 1000) / 10 : null;
          chipEl.replaceWith(chipEl = chgText(d));
        }
      });
    }

    function setRange(r) {
      if (r === curRange) return;
      curRange = r;
      ranges.querySelectorAll('.qpc-pill').forEach(function (b) {
        b.setAttribute('aria-checked', b.getAttribute('data-range') === r ? 'true' : 'false');
      });
      function apply(payload) {
        if (curRange !== r) return; // a faster later click won
        var next = resolveIndex(ix.key, payload);
        if (!next) return;
        cur = next;
        valEl.textContent = fmtPts(cur.level);
        scrubDate.textContent = IDXR_TEXT[r];
        chipEl.replaceWith(chipEl = chgText(cur.change_pct));
        paintIdxStats();
        drawIdx();
      }
      if (idxPayloadCache[r]) { apply(idxPayloadCache[r]); return; }
      D.indexes(r)
        .then(function (payload) { if (!payload) throw new Error('no index'); idxPayloadCache[r] = payload; apply(payload); })
        .catch(function () { /* keep the current range on failure */ });
    }

    productEl.appendChild(el('h2', 'qpt-pv-relhead', 'Products in this index (' + ix.members.length + ')'));
    var grid = el('div', 'qpt-table qpt-ix-list');
    var members = ix.members.slice().sort(function (a, b) { return (b.price_cents || 0) - (a.price_cents || 0); });
    var memShown = 0;
    var memMoreWrap = el('div', 'qpt-more-wrap');
    var memMore = el('button', 'qpt-btn qpt-more');
    memMore.type = 'button';
    memMoreWrap.appendChild(memMore);
    function moreMembers() {
      var next = members.slice(memShown, memShown + ROW_PAGE);
      next.forEach(function (p) { grid.appendChild(row(p, { grouped: !!ix.setName })); });
      memShown += next.length;
      var rest = members.length - memShown;
      memMoreWrap.hidden = rest <= 0;
      memMore.textContent = 'Show ' + Math.min(ROW_PAGE, rest) + ' more (' + rest + ' left)';
      return next[0];
    }
    memMore.addEventListener('click', function () {
      var before = grid.children.length;
      moreMembers();
      var first = grid.children[before];
      if (first) first.focus({ preventScroll: true });
    });
    moreMembers();
    productEl.appendChild(grid);
    productEl.appendChild(memMoreWrap);
    productEl.appendChild(el('p', 'qpt-d-note qpt-ix-foot',
      'Equal-weight index anchored to MSRP, so 100 means the set trades at its launch retail price and 200 means double it. ' +
      'Each product is measured in USD against its USD MSRP, so a currency move does not shift the level. ' +
      'Sets that have not released yet are excluded, because preorder prices are not set performance. ' +
      'Market prices, updated daily.'));

    requestAnimationFrame(drawIdx);

    document.title = ix.name + ' | ' + baseTitle;
    window.scrollTo(0, 0);
    h1.focus({ preventScroll: true });
  }

  /* every set index, newest set first (?index=sets) */
  function renderAllSetsPage(idx) {
    productEl.textContent = '';
    productEl.appendChild(trackerHomeBtn());
    var wrap = el('div', 'qpt-ixdir');
    var head = el('div', 'qpt-pv-head');
    var headTxt = el('div');
    var h1 = el('h1', 'qpt-pv-name', 'Set indexes');
    h1.tabIndex = -1;
    headTxt.appendChild(h1);
    headTxt.appendChild(el('p', 'qpt-pv-meta', (idx.sets || []).length + ' sets · newest first · 100 means launch price'));
    head.appendChild(headTxt);
    wrap.appendChild(head);
    var list = el('div', 'qpt-ixtable');
    (idx.sets || []).filter(function (s) { return s.level != null; })
      .sort(function (a, b) { return bySetAge(a.set_name, b.set_name); })
      .forEach(function (s) {
        list.appendChild(ixRow('set:' + s.set_name, setLabel(s.set_name), (s.covered != null ? s.covered : s.count) + ' products',
          s.level, s.change_pct, s.series, s.set_name));
      });
    wrap.appendChild(list);
    productEl.appendChild(wrap);
    document.title = 'Set indexes | ' + baseTitle;
    window.scrollTo(0, 0);
    h1.focus({ preventScroll: true });
  }

  /* ---------- routing: market <-> product <-> index ---------- */
  function showMarket() {
    if (widget) { widget.destroy(); widget = null; }
    productEl.hidden = true;
    productEl.textContent = '';
    marketEl.hidden = false;
    root.setAttribute('data-view', 'market');
    document.title = baseTitle;
    if (window.QuazaTrackNav) window.QuazaTrackNav.armSegs();
  }
  function showView(kind) {
    if (widget) { widget.destroy(); widget = null; }
    closePanel();
    marketEl.hidden = true;
    productEl.hidden = false;
    root.setAttribute('data-view', kind);
  }
  /* Any tracked product by Track id (set pages and search link here): one ~5 KB history file
     carries its series and facts; the set list names its set. */
  function showCoverageProduct(id) {
    showView('product');
    productEl.textContent = '';
    productEl.appendChild(trackerHomeBtn());
    var sk = el('div', 'qpt-skel'); sk.style.height = '320px'; productEl.appendChild(sk);
    Promise.all([D.history(id), D.sets(), D.usdToCad()]).then(function (r) {
      var h = r[0];
      if (!h) { showMarket(); return; }
      var set = ((r[1] && r[1].sets) || []).filter(function (s) { return s.id === h.set_id; })[0] || {};
      var toCad = r[2] || 1;
      var last = lastOf(h.usd_cents);
      var name = h.name || ('Product ' + id);
      if (h.number && name.slice(-(h.number.length + 3)) === ' - ' + h.number) name = name.slice(0, -(h.number.length + 3));
      var p = {
        id: String(id), _tcg: Number(id), _cov: h, _set: set,
        name: name + (h.number ? ' #' + h.number : ''),
        set_name: (set.display_name || set.name || '') + (set.lang === 'JP' ? ' (Japanese)' : ''),
        era: set.era_name || null,
        type: h.kind === 'card' ? 'single' : 'sealed',
        language: h.lang || set.lang || 'EN',
        image_url: D.imageUrl(id, 400),
        price_cents: last ? Math.round(last.v * toCad) : null,
        change7d_pct: changeOver(h.usd_cents, 7),
        shopify_handle: null,
        _load: function (range) { return D.historyDetail(h, range, toCad, null, { id: String(id), name: name }); }
      };
      if (!byId[p.id]) byId[p.id] = p;
      renderProductView(p);
    }).catch(function () { showMarket(); });
  }
  function showProduct(id) {
    var p = byId[id];
    if (!p && /^\d+$/.test(String(id))) { showCoverageProduct(id); return; }
    if (!p) { showMarket(); return; }
    showView('product');
    renderProductView(p);
  }
  function showIndexPage(key) {
    if (key === 'sets') {
      if (!lastIdx) { showMarket(); return; }
      showView('index');
      renderAllSetsPage(lastIdx);
      return;
    }
    var ix = resolveIndex(key);
    if (!ix) { showMarket(); return; }
    showView('index');
    renderIndexPage(ix);
  }
  function navigateToProduct(id) {
    var u = new URL(location.href);
    u.searchParams.set('product', id);
    u.searchParams.delete('index');
    history.pushState({ qpt: id, fromMarket: root.getAttribute('data-view') === 'market' }, '', u);
    showProduct(id);
  }
  function navigateToIndex(key) {
    var u = new URL(location.href);
    u.searchParams.set('index', key);
    u.searchParams.delete('product');
    history.pushState({ qidx: key, fromMarket: root.getAttribute('data-view') === 'market' }, '', u);
    showIndexPage(key);
  }
  /* a plain click routes in place; a modified click opens the link the browser's way */
  root.addEventListener('click', function (ev) {
    if (ev.defaultPrevented || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button) return;
    var gi = ev.target.closest('[data-goidx]');
    if (gi && root.contains(gi)) { ev.preventDefault(); navigateToIndex(gi.getAttribute('data-goidx')); return; }
    var op = ev.target.closest('[data-open]');
    if (op && root.contains(op)) { ev.preventDefault(); navigateToProduct(op.getAttribute('data-open')); }
  });
  window.addEventListener('popstate', function (ev) {
    if (ev.state && ev.state.qpt) showProduct(ev.state.qpt);
    else if (ev.state && ev.state.qidx) showIndexPage(ev.state.qidx);
    else showMarket();
  });

  /* ---------- market controls ---------- */
  if (mktEl) mktEl.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-mkt]');
    if (b) setMode(b.getAttribute('data-mkt'));
  });
  if (erasEl) erasEl.addEventListener('click', function (ev) {
    var t = ev.target.closest('[data-era]');
    if (!t || t.getAttribute('aria-pressed') === 'true') return;
    applyEra(t.getAttribute('data-era') || null);
  });
  if (setsEl) setsEl.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-set]');
    if (!b || b.getAttribute('aria-pressed') === 'true') return;
    applySet(b.getAttribute('data-set') || null, { keepType: true });
  });
  /* the chips' row: arrows for a mouse (CSS shows them only where a pointer hovers), and a fade on
     whichever side has more */
  if (stripEl && setsEl) {
    stripSync = function () {
      var max = setsEl.scrollWidth - setsEl.clientWidth;
      stripEl.classList.toggle('can-prev', setsEl.scrollLeft > 4);
      stripEl.classList.toggle('can-next', setsEl.scrollLeft < max - 4);
    };
    setsEl.addEventListener('scroll', stripSync, { passive: true });
    window.addEventListener('resize', stripSync);
    stripEl.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-dir]');
      if (!b) return;
      setsEl.scrollBy({ left: Number(b.getAttribute('data-dir')) * Math.max(160, setsEl.clientWidth * 0.75), behavior: reduced() ? 'auto' : 'smooth' });
    });
  }
  if (viewEl) viewEl.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-v]');
    if (b) setView(b.getAttribute('data-v'));
  });
  if (sortEl) sortEl.addEventListener('change', function () { setSort(sortEl.value); });
  catalogEl.addEventListener('click', function (ev) {
    var th = ev.target.closest('[data-th]');
    if (th) {
      var k = th.getAttribute('data-th');
      setSort(sort === k + '-desc' ? k + '-asc' : k + '-desc');
      return;
    }
    var all = ev.target.closest('.qpt-grp-all[data-set]');
    if (all) applySet(all.getAttribute('data-set'), { scroll: true });
  });
  moreBtn.addEventListener('click', function () {
    var before = catalogEl.querySelectorAll('a[data-open]').length;
    shown += moreBtn.getAttribute('data-step') === 'groups' ? GROUP_PAGE : view === 'grid' ? CARD_PAGE : ROW_PAGE;
    renderCatalog(false);
    var link = catalogEl.querySelectorAll('a[data-open]')[before];
    if (link) link.focus({ preventScroll: true }); // keyboard users carry on from where the new products start
  });
  if (mvTabs) mvTabs.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-mv]');
    if (!b) return;
    moverDir = b.getAttribute('data-mv');
    mvTabs.querySelectorAll('[data-mv]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    renderMovers();
  });
  if (mvAll) mvAll.addEventListener('click', function () {
    activeSet = null; activeEra = null; activeType = null;
    setSort(moverDir === 'up' ? 'change-desc' : 'change-asc', { scroll: true });
  });
  if (ixTabs) ixTabs.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-ix]');
    if (!b) return;
    ixKind = b.getAttribute('data-ix');
    ixTabs.querySelectorAll('[data-ix]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    renderIxTable();
    fadeIn(ixList);
  });
  if (ixMore) ixMore.addEventListener('click', function () {
    ixAllOpen = !ixAllOpen;
    renderIxTable();
    if (!ixAllOpen) document.getElementById('qpt-indexes').scrollIntoView({ block: 'start' });
  });

  /* ---------- search: every tracked product (~14,000) and every set page ----------
     The search files (~280 KB compressed) load the first time someone focuses the box. Every word must
     match (name, set, number, code), accents ignored; sets first, then the most valuable products. */
  var searchIndex = null, searchLoading = null, searchTimer = 0;
  function loadSearchIndex() {
    if (searchLoading) return searchLoading;
    searchLoading = Promise.all([D.search('en'), D.search('jp'), D.sets(), D.usdToCad()]).then(function (r) {
      var sets = {};
      ((r[2] && r[2].sets) || []).forEach(function (st) { sets[st.id] = st; });
      var rows = [];
      [r[0], r[1]].forEach(function (f, jp) {
        if (!f) return;
        var ix = {};
        f.fields.forEach(function (k, i) { ix[k] = i; });
        f.rows.forEach(function (rw) {
          var st = sets[rw[ix.set_id]] || {};
          var setName = (st.display_name || st.name || '') + (jp ? ' (Japanese)' : '');
          var number = rw[ix.number];
          var nm = rw[ix.name];
          if (number && nm.slice(-(number.length + 3)) === ' - ' + number) nm = nm.slice(0, -(number.length + 3));
          rows.push({
            id: rw[ix.id], name: nm, number: number, set: setName,
            usd: rw[ix.usd_cents], c7: ix.change_7d_pct != null ? rw[ix.change_7d_pct] : null,
            key: fold(nm + ' ' + setName + ' ' + (number || '') + (st.code ? ' ' + st.code : '') + (jp ? ' japanese jp' : ''))
          });
        });
      });
      var codes = {};
      ((r[2] && r[2].sets) || []).forEach(function (st) { if (st.code) codes[st.id] = st.code; });
      var setLinks = Array.prototype.map.call(root.querySelectorAll('[data-qpt-setsmenu] a[data-i]'), function (a) {
        var id = a.getAttribute('data-i');
        var jp = a.closest('.qpt-sm-cols').getAttribute('data-l') === 'JP';
        var name = a.querySelector('span').textContent + (jp ? ' (Japanese)' : '');
        return { name: name, href: a.getAttribute('href'), key: fold(name + ' ' + (codes[id] || '') + (jp ? ' jp' : '')) };
      });
      searchIndex = { rows: rows, sets: setLinks, toCad: r[3] || 1 };
      return searchIndex;
    }).catch(function () { searchLoading = null; });
    return searchLoading;
  }
  function clearSearch() {
    searchEl.value = '';
    resultsEl.hidden = true;
    resultsEl.textContent = '';
    searchX.hidden = true;
  }
  function searchAll() {
    clearTimeout(searchTimer);
    var raw = searchEl.value.trim();
    var q = fold(raw);
    searchX.hidden = !raw;
    if (q.length < 2) { resultsEl.hidden = true; resultsEl.textContent = ''; return; }
    searchTimer = setTimeout(function () {
      loadSearchIndex().then(function (si) {
        if (!si || fold(searchEl.value.trim()) !== q) return;
        var words = q.split(/\s+/).filter(Boolean);
        var hit = function (k) { for (var i = 0; i < words.length; i++) if (k.indexOf(words[i]) === -1) return false; return true; };
        var sets = si.sets.filter(function (st) { return hit(st.key); }).slice(0, 10);
        var found = si.rows.filter(function (r) { return hit(r.key); });
        found.sort(function (a, b) { return (b.usd || 0) - (a.usd || 0); });
        resultsEl.textContent = '';
        if (!sets.length && !found.length) {
          resultsEl.appendChild(el('p', 'qpt-results-note', 'Nothing in Quaza Track matches “' + raw + '”.'));
          resultsEl.hidden = false;
          return;
        }
        if (sets.length) {
          resultsEl.appendChild(el('h2', 'qpt-results-h', sets.length === 1 ? 'Set' : 'Sets'));
          var chips = el('div', 'qpt-results-sets');
          sets.forEach(function (st) { var a = el('a', 'qpt-chipbtn', st.name); a.href = st.href; chips.appendChild(a); });
          resultsEl.appendChild(chips);
        }
        if (found.length) {
          resultsEl.appendChild(el('h2', 'qpt-results-h', 'Cards and products'));
          var list = el('div', 'qpt-table');
          found.slice(0, 12).forEach(function (r) {
            list.appendChild(row({
              id: String(r.id), name: r.name + (r.number ? ' #' + r.number : ''),
              price_cents: r.usd != null ? Math.round(r.usd * si.toCad) : null, change7d_pct: r.c7
            }, { image: D.imageUrl(r.id, 200), meta: r.set }));
          });
          resultsEl.appendChild(list);
          if (found.length > 12) resultsEl.appendChild(el('p', 'qpt-results-note',
            'The 12 most valuable of ' + found.length.toLocaleString('en-CA') + '. Add a word to narrow it.'));
        }
        resultsEl.hidden = false;
      });
    }, 140);
  }
  searchEl.addEventListener('input', searchAll);
  searchEl.addEventListener('focus', loadSearchIndex, { once: true });
  searchEl.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && searchEl.value) { ev.stopPropagation(); clearSearch(); }
    if (ev.key === 'Enter') { // Enter opens the top result
      var first = resultsEl.querySelector('a');
      if (first) { ev.preventDefault(); first.click(); }
    }
  });
  searchX.addEventListener('click', function () { clearSearch(); searchEl.focus(); });

  /* ---------- boot ---------- */
  function loadIndexes() {
    D.indexes('3m')
      .then(function (idx) {
        if (!idx) throw new Error('no indexes');
        lastIdx = idx;
        idxPayloadCache = { '3m': idx };
        renderIndexBox(idx);
        renderIxTable();
        renderPulse();
        if (activeSet) renderCatalog(false); // the set card gains its index figure
        var u0 = new URL(location.href);
        var wantIndex = u0.searchParams.get('index');
        if (wantIndex && !u0.searchParams.get('product') && (wantIndex === 'sets' || resolveIndex(wantIndex))) {
          // this entry becomes the market; the index view is pushed on top, so Back returns to the market
          var clean = new URL(location.href);
          clean.searchParams.delete('index');
          history.replaceState({}, '', clean);
          navigateToIndex(wantIndex);
        }
      })
      .catch(function () {
        // the index parts are additive: hide them rather than break the page
        ['qpt-index', 'qpt-indexes'].forEach(function (id) { var n = document.getElementById(id); if (n) n.hidden = true; });
      });
  }
  function fail() {
    catalogEl.textContent = '';
    catalogEl.removeAttribute('aria-busy');
    var s = el('div', 'qpt-empty');
    s.appendChild(el('p', null, 'The market data didn’t load.'));
    var r = el('button', 'qpt-btn', 'Try again');
    r.type = 'button';
    r.addEventListener('click', boot);
    s.appendChild(r);
    catalogEl.appendChild(s);
  }
  function boot() {
    D.catalog()
      .then(function (data) {
        if (!data) throw new Error('no catalog');
        products = data.products || [];
        byId = {};
        products.forEach(function (p) { byId[p.id] = p; });
        logoMap = data.set_logos || {};
        // Shopify Markets picks the visitor's currency; the CAD market data converts at the day's rate
        var shopCur = (root.getAttribute('data-currency') || 'CAD').toUpperCase();
        C.setMoney(shopCur, (data.rates || {})[shopCur]);
        if (data.updated_at) {
          var dt = new Date(data.updated_at);
          updatedAtText = 'Last updated ' + dt.toLocaleDateString('en-CA', { month: 'long', day: 'numeric', year: 'numeric' }) + '. ';
          if (updatedEl) updatedEl.textContent = ' · Updated ' + dt.toLocaleDateString('en-CA', { month: 'short', day: 'numeric' });
          if (updatedFoot) updatedFoot.textContent = 'Prices last updated ' + dt.toLocaleDateString('en-CA', { month: 'long', day: 'numeric', year: 'numeric' }) + '.';
        }
        buildTaxonomy();

        var params = new URL(location.href).searchParams;
        if (params.get('market') === 'singles') mode = 'singles';
        var wantSet = params.get('set'), wantEra = params.get('era'), wantType = params.get('ptype'), wantSort = params.get('sort');
        if (wantSet && !products.some(function (p) { return p.set_name === wantSet; })) wantSet = null;
        if (wantEra && !products.some(function (p) { return eraOf(p) === wantEra; })) wantEra = null;
        activeSet = wantSet;
        activeEra = wantEra;
        if (activeSet && activeEra && (SET_INFO[activeSet] || {}).era !== activeEra) activeEra = null;
        activeType = wantType && ptypeDef(wantType) ? wantType : null;
        if (wantSort && sortEl && sortEl.querySelector('option[value="' + wantSort + '"]')) { sort = wantSort; sortEl.value = wantSort; }
        navSync();
        renderPulse();
        renderMovers();
        markView();
        renderFilters();
        renderCatalog(true);
        loadIndexes();

        /* Arriving with a filter means someone followed a link to a filtered list: land on it. */
        if ((activeSet || activeEra || activeType) && !params.get('product')) {
          var landing = document.getElementById('qpt-browse');
          if (landing) landing.scrollIntoView({ block: 'start' });
        }

        var want = params.get('product');
        // ?handle= is the crawlable form of the same deep link, for product pages that know only a handle
        if (!want && params.get('handle')) {
          var hd = params.get('handle');
          for (var hi = 0; hi < products.length; hi++) if (products[hi].shopify_handle === hd) { want = String(products[hi].id); break; }
        }
        if (want && (byId[want] || /^\d+$/.test(want))) {
          var clean = new URL(location.href);
          clean.searchParams.delete('product');
          clean.searchParams.delete('handle');
          history.replaceState({}, '', clean);
          navigateToProduct(want);
        }
      })
      .catch(fail);
  }
  boot();
})();
